import { GetServerSideProps } from 'next'

import { tagMap } from '@/utils/constants'
import { serverSidePropsFor } from '@/utils/helpers.server'

import DecksPage from '.'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const slug = context.query.slug as string[]
  let url
  if (context.query.f && context.params?.slug) {
    // Deck filters
    const params = {
      cmdr: slug[0],
      dir: 'decks',
      f: context.query.f as string,
    }
    const queryString = new URLSearchParams(params).toString()
    url = `${process.env.NEXT_PUBLIC_EDHREC_API_URL}/filters/?${queryString}`
  } else {
    const subDirs = slug.map((slug: string) => (slug in tagMap ? tagMap[slug as keyof typeof tagMap] : slug))
    const resolvedUrl = subDirs.length > 0 ? `/${subDirs.join('/')}` : ''
    url = `${process.env.NEXT_PUBLIC_EDHREC_JSON_URL}/pages/decks/${context.query.commander}${resolvedUrl}.json`
  }

  return serverSidePropsFor(url, context.req.headers)
}

export default DecksPage
